var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSignInViewGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 9.20463H19.75V9.16658H11.5V12.8333H16.6806C15.9248 14.9677 13.8939 16.4999 11.5 16.4999C8.46267 16.4999 6.00004 14.0373 6.00004 10.9999C6.00004 7.96254 8.46267 5.49992 11.5 5.49992C12.9021 5.49992 14.1776 6.02883 15.1488 6.89279L17.7416 4.3C16.1045 2.77421 13.9145 1.83325 11.5 1.83325C6.43775 1.83325 2.33337 5.93763 2.33337 10.9999C2.33337 16.0622 6.43775 20.1666 11.5 20.1666C16.5623 20.1666 20.6667 16.0622 20.6667 10.9999C20.6667 10.3853 20.6035 9.78534 20.4884 9.20463Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38965 6.73329L6.40136 8.942C7.21627 6.92442 9.18986 5.49992 11.4994 5.49992C12.9014 5.49992 14.177 6.02884 15.1482 6.89279L17.741 4.3C16.1038 2.77421 13.9139 1.83325 11.4994 1.83325C7.97848 1.83325 4.92507 3.82104 3.38965 6.73329Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 20.167C13.8679 20.167 16.0193 19.2609 17.6459 17.7873L14.8088 15.3866C13.8576 16.11 12.6952 16.5013 11.5001 16.5003C9.11585 16.5003 7.09139 14.98 6.32873 12.8584L3.33948 15.1615C4.85656 18.1301 7.93748 20.167 11.5001 20.167Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 9.20479H19.75V9.16675H11.5V12.8334H16.6805C16.319 13.8493 15.6678 14.737 14.8073 15.3868L14.8087 15.3859L17.6458 17.7866C17.445 17.969 20.6667 15.5834 20.6667 11.0001C20.6667 10.3855 20.6034 9.7855 20.4884 9.20479Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSignInViewGoogle);
export default __webpack_public_path__ + "static/media/HeaderSignInViewGoogle.354c5ab018ed2f40048cfb719e8ad81b.svg";
export { ForwardRef as ReactComponent };